import axios from 'axios';
import '../../common/axiosInterceptor/axios-interceptor';

export const GetHospitalUserCredentials = async (hospitalId) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api/getHospitalUserCredentials`,
    authRequired: true,
    data: {
      hospitalId,
    },
  });
};
